<template>
  <!--
    	作者：luoyiming
    	时间：2019-10-25
    	描述：会员-添加
    -->
  <el-dialog title="添加分类" :visible.sync="dialogVisible" @close='dialogFormVisible' :close-on-click-modal="false"
    :close-on-press-escape="false">
    <el-form :model="form" :rules="formRules" ref="form">
      <el-form-item label="分类名称" :label-width="formLabelWidth">
        <el-input v-model="form.name" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="排序" :label-width="formLabelWidth">
        <el-input type="number" v-model="form.sort" autocomplete="off"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button type="primary" @click="addCategory">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import SharingApi from '@/api/sharing.js';
  export default {
    data() {
      return {
        form: {
          /*昵称*/
          name: '',
          sort: 1,


        },
        formRules: {

        },
        /*左边长度*/
        formLabelWidth: '120px',
        /*是否显示*/
        dialogVisible: false
      };
    },
    props: ['open_add'],
    created() {
      this.dialogVisible = this.open_add;
    },
    methods: {
      /*添加分类*/
      addCategory() {
        let self = this;
        let params = this.form;
        self.$refs.form.validate((valid) => {
          if (valid) {
            self.loading = true;
            SharingApi.addCategory(params, true).then(data => {
                if (data.code == 1) {
                  self.$message({
                    message: data.msg,
                    type: 'success'
                  });
                  self.dialogFormVisible(true);
                } else {
                  self.$message.error('错了哦，这是一条错误消息');
                }
              })
              .catch(error => {

              });
          }
        });

      },

      /*关闭弹窗*/
      dialogFormVisible(e) {
        if (e) {
          this.$emit('closeDialog', {
            type: 'success',
            openDialog: false
          })
        } else {
          this.$emit('closeDialog', {
            type: 'error',
            openDialog: false
          })
        }
      }

    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/sharing/sharing/category/Add.vue